export { TechnologiesTable } from './TechnologiesTable';
